module.exports = new __parcel__URL__("snare_4.54b1f023.mp3").toString();